import APIError from '../APIError';

class BricksError extends APIError {
  constructor(code, details = null) {
    super(code, 'BricksError', details);
  }
}

export default BricksError;
